import request from '@/router/axios';

export const getList = (current, size, params) => {
  return request({
    url: '/api/blade-resource/sms/list?tenantId=' + params.tenantId,
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getDetail = (id, tenantId) => {
  return request({
    url: '/api/blade-resource/sms/detail?tenantId=' + tenantId,
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids, tenantId) => {
  return request({
    url: '/api/blade-resource/sms/remove?tenantId=' + tenantId,
    method: 'post',
    params: {
      ids,
    }
  })
}

export const add = (row) => {
  return request({
    url: '/api/blade-resource/sms/submit?tenantId=' + row.tenantId,
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: '/api/blade-resource/sms/submit?tenantId=' + row.tenantId,
    method: 'post',
    data: row
  })
}

export const enable = (id, tenantId) => {
  return request({
    url: '/api/blade-resource/sms/enable?tenantId=' + tenantId,
    method: 'post',
    params: {
      id
    }
  })
}

export const send = (code, phones, params, tenantId) => {
  return request({
    url: '/api/blade-resource/sms/endpoint/send-message?tenantId=' + tenantId,
    method: 'post',
    params: {
      code,
      phones,
      params,
    }
  })
}

